import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { ITag } from '../../types/tags';
import { containsJsonQuery } from '../jsonQuery/containsJsonQuery';

/**
 * Проверяет вхождение jsonQuery переданного тэга в jsonQuery
 * @param {ITag} tag - тэг для сравнения
 * @param {IJsonQuery} jsonQuery - эталонный jsonQuery
 * @returns {boolean}
 */
export const checkTagInJsonQuery = (tag: ITag, jsonQuery: IJsonQuery): boolean => {
  return containsJsonQuery(jsonQuery, tag.jsonQuery);
};
